import React, { FC } from 'react'

import FastWidgetDefault from 'tasktracker/FastWidget'
import { AnyType } from '@centra/centra-ui'

const FakeFastWidget: FC<Parameters<typeof FastWidgetDefault.FastWidget>[0]> = () => {
  return null
}

const FastWidgetRemote = await import('tasktracker/FastWidget')
  .then(res => res.FastWidget || FakeFastWidget)
  .catch(() => FakeFastWidget)

export const FastWidget = (props: {
  path: string
  push: (url: string) => void
  query: string
  pushOld?: ((payload: Record<AnyType, AnyType>) => void) | undefined
}) => {
  return <FastWidgetRemote {...props} />
}
